import axios from "axios";
import env from "app/utils/env";

export const FETCH_DISTRIBUTIONS = "FETCH_DISTRIBUTIONS";
export const FETCH_DISTRIBUTIONS_REQUEST = "FETCH_DISTRIBUTIONS_REQUEST";
export const FETCH_DISTRIBUTIONS_SUCCESS = "FETCH_DISTRIBUTIONS_SUCCESS";

export const FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION =
	"FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION";
export const FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_REQUEST =
	"FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_REQUEST";
export const FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_SUCCESS =
	"FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_SUCCESS";

export const HOTEL_ONLY_PREBOOK = "HOTEL_ONLY_PREBOOK";
export const HOTEL_ONLY_PREBOOK_REQUEST = "HOTEL_ONLY_PREBOOK_REQUEST";
export const HOTEL_ONLY_PREBOOK_SUCCESS = "HOTEL_ONLY_PREBOOK_SUCCESS";
export const HOTEL_ONLY_PREBOOK_FAILURE = "HOTEL_ONLY_PREBOOK_FAILURE";

// c'est le même endpoint que pour fetchDistributions
// mais on le différencie pour le reducer
// afin de ne pas écraser les données de distribution
// dans le store redux
// lorsque l'on charge la description de l'hébergement
// dans la page de confirmation et de payement
export const fetchHotelOnlyAccommodationDescription = payload => {
	const hotelOnlyUrl = env("HOTEL_ONLY_API_URL");
	return {
		type: FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION,
		promise: axios.post(`${hotelOnlyUrl}/accommodation`, { ...payload }),
	};
};

export const fetchDistributions = payload => {
	const hotelOnlyUrl = env("HOTEL_ONLY_API_URL");
	return {
		type: FETCH_DISTRIBUTIONS,
		promise: axios.post(`${hotelOnlyUrl}/accommodation`, { ...payload }),
	};
};

export const hotelOnlyPrebook = payload => {
	const hotelOnlyUrl = env("HOTEL_ONLY_API_URL");
	return {
		type: HOTEL_ONLY_PREBOOK,
		promise: axios.post(`${hotelOnlyUrl}/preBook`, { ...payload }),
	};
};
